import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_237 implements Validator {

    public static id = 'CTRL_237';
    private message = 'error.ctr_237';


    public LOG: LogService = new LogService(CTRL_237);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_237.id + '_');
        const ctrlMap = this.formExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form);

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChamp = ctrl.value.rgCtrls.firstChamp;
                const secondNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const secondCtrl = form.controls[secondNameWithStepId];
                if (ctrlMap.get(firstChamp) && secondCtrl.value.includes(form.controls[ctrlMap.get(firstChamp)].value)) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
